import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index.js'; // Import the router
import axios from 'axios';
import { getSessionId } from './utils/session';
import socket from './utils/socket';

// Handle referral links before app initialization
const handleReferralRoute = async () => {
  const path = window.location.pathname;
  const referralMatch = path.match(/^\/r\/([A-Za-z0-9]+)$/);
  
  if (referralMatch) {
    const referralCode = referralMatch[1];
    console.log('Referral route detected:', referralCode);
    
    try {
      // Make a request to your backend to validate the referral code
      await axios.get(`${process.env.VUE_APP_API_URL}/r/${referralCode}`);
      // If successful, the backend should have already redirected
      // But if we reach here, redirect manually
      window.location.href = `/register?code=${referralCode}`;
    } catch (error) {
      console.error('Error processing referral:', error);
      // Redirect to register anyway
      window.location.href = `/register?code=${referralCode}`;
    }
    return true; // Indicate we're handling a referral route
  }
  return false; // Not a referral route
};

// Check for referral route before initializing the app
handleReferralRoute().then((isReferralRoute) => {
  if (isReferralRoute) {
    return; // Don't initialize the app, we're redirecting
  }

  // Normal app initialization continues here
  getSessionId();
  
  function trackActiveUser() {
    const sessionId = localStorage.getItem('sessionId');
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const data = {
      sessionId,
      page: window.location.pathname,
      username: user.fullName || 'Anonymous', // Replace with the actual username if available
      timestamp: new Date().toISOString(),
    };

    axios.post(`${process.env.VUE_APP_API_URL}/api/track-visit`, data)
    .catch((err) => console.error('Error tracking visit:', err));
    socket.emit('user-active', data);
  }

  // Track user activity on load
  trackActiveUser();

  const app = createApp(App);

  // Set up Axios interceptor
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 403) {
        // Token expired or not valid
        localStorage.removeItem('user');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('isBusiness');
        localStorage.removeItem('token');
        localStorage.removeItem('shoppingBagItems');
        localStorage.removeItem('checkoutCartItems');
        localStorage.removeItem('billingDetails')
        location.reload();
        router.push('/login'); // Redirect to login page
      }
      return Promise.reject(error);
    }
  );

  // Add router navigation guard to track page visits
  router.afterEach(() => {
    // Track page visits through router navigation
    setTimeout(() => {
      trackActiveUser();
    }, 100);
  });

  app.use(router).mount('#app'); // Use the router in your app
});
